import React, { useEffect, useState } from 'react';
import { ROUTE } from 'constant';
import { actions, ACTIONS_TYPES } from 'redux/local';
import { rollRelativeTimeRange } from 'utils/time';
import { useSelector } from 'react-redux';
import Shared from 'screens/shared';
import { _t } from 'utils';
import Grapher from './Grapher';
import GraphController from './GraphController';

export default ({ match }) => {
  const [refreshCounter, setRefreshCounter] = useState(0);
  const clusterId = match.params?.id;

  const {
    [ACTIONS_TYPES.DATABASE.POSTGRESQL.GET]: database = {},
    timeRangeSettings: controllerState = {},
  } = useSelector((e) => e);

  const refresh = () => {
    setRefreshCounter((prevCount) => prevCount + 1);
  };

  const updateTimeRange = () => (
    actions.common.quickUpdate({
      timeRangeSettings: {
        ...controllerState,
        range: rollRelativeTimeRange(controllerState.range),
      },
    })
  );

  useEffect(() => {
    updateTimeRange();

    let { refreshInterval } = controllerState;
    if (typeof refreshInterval === 'undefined') {
      refreshInterval = 30000;
    }

    let intervalCleaner;
    if (refreshInterval > 1000) {
      intervalCleaner = setInterval(refresh, refreshInterval);
    }

    return () => {
      clearInterval(intervalCleaner);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    actions.database.postgresql.get({ id: clusterId });
  }, [clusterId]);

  const onChange = (model) => {
    actions.common.quickUpdate({ timeRangeSettings: { ...controllerState, ...model } });
    refresh();
  };

  const handleRefresh = () => {
    updateTimeRange();
    refresh();
  };

  return (
    <Shared.widgets.Page
      title={_t('DATABASES.MONITORING.SECTION_TITLE')}
      route={ROUTE.DASHBOARD.DATABASES}
      isDeleteButton={false}
      isEditButton={false}
      strapTitle={database.displayName}
    >
      <div className="screen-monitoring" style={{ flexWrap: 'wrap', justifyContent: 'space-between', flexDirection: 'row' }}>
        <GraphController onChange={onChange} model={controllerState} onRefresh={handleRefresh} />
        {
          database.properties
          && <Grapher clusterId={clusterId} timeRangeSettings={controllerState} refresh={refreshCounter} database={database.properties} />
        }
      </div>
    </Shared.widgets.Page>
  );
};
